export const selectStyle = {
  control: base => ({
    ...base,
    minWidth: 250,
  })
};

export const teamSelectStyle = {
  control: base => ({
    ...base,
    minWidth: 250,
    marginLeft: 'auto'
  })
};
